import { FunctionComponent, PropsWithChildren } from "react";

import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";

import { FormInfobox } from "@/forms-design-system/FormInfobox";
import { Warning } from "@/icons/outlined";

interface PaymentErrorAlertProps {
  paymentError?: string | null;
}

const PaymentErrorAlert: FunctionComponent<PropsWithChildren<PaymentErrorAlertProps>> = ({ paymentError }) => {
  if (!paymentError) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        maxHeight: paymentError ? 1000 : 0,
        transition: paymentError ? "max-height 0.5s ease-in-out" : "none",
        overflow: "hidden",
        marginBottom: paymentError ? theme.spacing(2) : 0,
        zIndex: 10,
      })}
    >
      <Grid item xs={12}>
        <FormInfobox icon={<Warning />} variant="error" description={paymentError} />
      </Grid>
    </Box>
  );
};

export default PaymentErrorAlert;
